import { errHandler } from "utils/common";
import api from "utils/api";

export default class AuditDeletedData {
  getAll = (params = {}) => {
    return new Promise((resolve, reject) => {
      api
        .get("/api/audit/deleted-data", { params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };
}
